export default __webpack_public_path__ + "static/media/foto_onderzoek.bf4ec4bc.png";